<template>
  <div class="animated fadeIn">
    <b-card-text class="text-left">
      <p>
        Uh oh!
        <template v-if="errorCode >= 400 && errorCode < 500">
          <template v-if="errorMessage == 'invalid_code' || errorMessage == 'code_expired'">
            It looks like the authorization code Slack provided us is invalid or expired.  This is usually caused by waiting too long between clicking 'Allow' after reviewing the permissions on Slack's website and beginning the installation process.  Please try again.

            <br /><br />
            If you experience this more than once <a href="mailto:support@chatacuity.com">please let us know</a>, and we will investigate immediately.
          </template>
          <template v-else-if="errorMessage == 'trial_expired'">
            It looks like this workspace has already completed a free trial.  Please email <a href="mailto:sales@chatacuity.com">sales@chatacuity.com</a> if you would like to try ChatAcuity again.
          </template>
          <template v-else>
            It looks like we're having some difficulty getting the information we need from Slack right now.  Please try again shortly.  

            <br /><br />
            If you experience this more than once <a href="mailto:support@chatacuity.com">please let us know</a>, and we will investigate immediately.
          </template>
          
        </template>
        <template v-else>
        </template>
      </p>

    </b-card-text>
  </div>
</template>


<script>
export default {
  name: 'Error',
  props: {
    msg: String
  },

  computed: {
    errorCode() {
      return this.$store.state.errorResponse.status
    },
    errorMessage() {
      return this.$store.state.errorResponse.data.message
    }
  },

  methods: {

  },

  mounted() {
    this.$store.commit('installProgress', 0)
  }
}
</script>